export const QUALIFICATION_METRICS = [
  { label: "Amount Spent", value: "AMOUNT_SPENT" },
  { label: "Points Earned", value: "POINTS_EARNED", disabled: true },
];

export const EVALUATION_WINDOW_TYPES = [
  {
    label: "Since Last Evaluation Date",
    value: "SINCE_LAST_EVALUATION_DATE",
    description:
      "Calculate qualifying <Tier Qualification Metric> from the previous date",
  },
  {
    label: "Custom rolling window",
    value: "ROLLING_X_MONTH_WINDOW",
    description: "",
  },
];

export const REVIEW_DATE_TYPES = [
  {
    label: "Member Enrollment Anniversary",
    value: "MEMBER_ENROLLMENT_ANNIVERSARY",
    description: "Tier is evaluated annually on the memeber's enrollment date",
  },
  {
    label: "Fixed Date",
    value: "FIXED_DATE",
    description: "Tier is evaluated annually starting on the selected date",
  },
];

export const HISTORICAL_QUALIFICATION_OPTIONS = [
  {
    label: "Calculate Initial Tier Using Historical Transactions",
    value: "ENABLED",
    description:
      "The member's historical transaction data is evaluated during enrollment to determine the starting tier.",
  },
  {
    label: "Assign Entry Tier to All New Members",
    value: "DISABLED",
    description:
      "All newly enrolled members are assigned to the program's entry tier regardless of previous transactions.",
  },
];

export const CURRENCY_OPTIONS = [
  { label: "USD", value: "USD" },
  { label: "EUR", value: "EUR" },
  { label: "GBP", value: "GBP" },
  { label: "CAD", value: "CAD" },
  { label: "AUD", value: "AUD" },
  { label: "MXN", value: "MXN" },
  { label: "BRL", value: "BRL" },
];

export const TIER_STATUS = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
};

export const MONTHS = [
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 },
];
